import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { FormulaService } from '../../services/formula/formula.service';
import { first, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class FormulaResolve implements Resolve<any> {

    constructor(private fs: FormulaService) { }

    resolve(route: ActivatedRouteSnapshot) {
        return this.fs.getFormulas().pipe(map(formulas => formulas)).pipe(first());
    }

}
